var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.submission.canEdit || _vm.fromDashboard
        ? _c(
            "v-layout",
            {
              staticClass: "action-button-container",
              attrs: {
                row: "",
                wrap: "",
                "text-xs-center": "",
                "text-sm-right": ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "action-button",
                      class: {
                        mobile: _vm.isMobile,
                        "margin-zero": _vm.marginZero
                      },
                      attrs: { fab: "", dark: "", color: "secondary" },
                      on: { click: _vm.editForm }
                    },
                    [_c("v-icon", [_vm._v("mdi-pencil")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "action-button",
                      class: {
                        mobile: _vm.isMobile,
                        "margin-zero": _vm.marginZero
                      },
                      attrs: { fab: "", dark: "", color: "secondary" },
                      on: { click: _vm.copyForm }
                    },
                    [_c("v-icon", [_vm._v("mdi-content-copy")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "action-button",
                      class: {
                        mobile: _vm.isMobile,
                        "margin-zero": _vm.marginZero
                      },
                      attrs: { fab: "", dark: "", color: "error" },
                      on: { click: _vm.deleteForm }
                    },
                    [_c("v-icon", [_vm._v("mdi-delete-outline")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showLoading ? _c("full-screen-loading-spinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44b1c95a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44b1c95a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/action-icons.vue
// module id = null
// module chunks = 